import { render, staticRenderFns } from "./ProOrganizationSearch.vue?vue&type=template&id=0fb790ca&scoped=true&"
import script from "./ProOrganizationSearch.vue?vue&type=script&lang=ts&"
export * from "./ProOrganizationSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb790ca",
  null
  
)

export default component.exports